import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'react-tippy'
import classNames from 'classnames/bind'
import styles from './AppliedTooltip.module.css'

let cx = classNames.bind(styles)

export const AppliedTooltip = ({ children, popoverContent, disabled }) => (
    <Tooltip 
        html={popoverContent}
        disabled={disabled}
        arrowSize='big'
        size="big"
        theme="applied"
        interactive
        arrow
    >
        {children}
    </Tooltip>
)

AppliedTooltip.propTypes = {
    children: PropTypes.node,
    popoverContent: PropTypes.node,
    disabled: PropTypes.bool
}
AppliedTooltip.displayName = 'AppliedTooltip'

export const PopoverContainer = ({ children, title, color }) => (
    <div className={styles.popover}>
        <div 
            className={styles.toolTipTitle}
            style={{ borderBottomColor: color }}
        >
            {title}
        </div>
        {children}
    </div>
) 

PopoverContainer.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string
}
PopoverContainer.displayName = 'PopoverContainer'

export const SynonymSuggestions = ({ synonyms, onClick }) => (
    <div className={styles.wordWrapper}>
        { 
            synonyms.map((synonym, i) => (
                <div
                    key={i}
                    className={styles.word}
                    onClick={() => onClick(synonym)}
                >
                    {synonym}
                </div>
            )) 
        }
    </div>
)

SynonymSuggestions.propTypes = {
    synonyms: PropTypes.array,
    onClick: PropTypes.func
}
SynonymSuggestions.displayName = 'SynonymSuggestions'


export const BaseSpan = ({ children, offsetKey, disabled, color, borderColor }) => (
    <span
        className={cx({
            baseSpan: true,
            handle: !disabled,
            greyHandle: disabled
        })}
        style={{
            borderColor,
            backgroundColor: color,
        }}
        data-offset-key={offsetKey}
    >
        {children}
    </span>
)

BaseSpan.propTypes = {
    children: PropTypes.node,
    offsetKey: PropTypes.string,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    borderColor: PropTypes.string
}
BaseSpan.displayName = 'BaseSpan'